import { trans } from "@mongez/localization";
import { money } from "@core/shared/utils";
import {
  useCurrentPaymentMethod,
  usePaymentMethodConfig,
  usePaymentPortalData,
} from "../hooks";

export function PaymentSummary() {
  const { paymentMethod } = useCurrentPaymentMethod();
  const { lessonsCount, offersCount, totalCost } = usePaymentPortalData();
  const paymentMethodConfig = usePaymentMethodConfig();

  return (
    <div className="rounded-lg bg-gray-50 dark:bg-gray-800/50 p-4">
      <h3 className="mb-2 font-semibold text-gray-900 dark:text-gray-100">
        {trans("invoices.paymentSummary")}
      </h3>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-300">
            {trans("invoices.paymentMethod")}:
          </span>
          <span className="font-medium text-gray-900 dark:text-gray-100">
            {trans(paymentMethodConfig[paymentMethod!]?.name || "")}
          </span>
        </div>
        
        {lessonsCount > 0 && (
          <div className="flex justify-between">
            <span className="text-gray-600 dark:text-gray-300">
              {trans("invoices.totalLessons")}:
            </span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {trans("grades.totalLessons", {
                count: lessonsCount,
              })}
            </span>
          </div>
        )}
        
        {offersCount > 0 && (
          <div className="flex justify-between">
            <span className="text-gray-600 dark:text-gray-300">
              {trans("invoices.totalOffers")}:
            </span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {trans("offers.totalOffers", {
                count: offersCount,
              })}
            </span>
          </div>
        )}
        
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-300">{trans("invoices.totalCost")}:</span>
          <span className="font-medium text-gray-900 dark:text-gray-100">{money(totalCost)}</span>
        </div>
      </div>
    </div>
  );
}
